
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entreprise/[slug]",
      function () {
        return require("private-next-pages/entreprise/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entreprise/[slug]"])
      });
    }
  